var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "data-balance-rechange" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("merchant.account_balance")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "rechange-middle" },
      [
        _c("div", { staticClass: "custom-breadcrumbs" }, [
          _c("i", {
            staticClass: "el-icon-arrow-left icon-back",
            on: {
              click: function ($event) {
                return _vm.onClickFistBread("Financial_Manage_Balance")
              },
            },
          }),
          _c(
            "span",
            {
              staticClass: "first-span",
              on: {
                click: function ($event) {
                  return _vm.onClickFistBread("Financial_Manage_Balance")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("data.recharge_record")))]
          ),
          _c("span", { staticStyle: { margin: "0 12px" } }, [_vm._v(" /")]),
          _c("span", [_vm._v(" " + _vm._s(_vm.$t("data.step")) + " 3")]),
        ]),
        _c(
          "div",
          { staticClass: "select-bank" },
          [
            _c(
              "el-form",
              {
                ref: "rechargeForm",
                attrs: {
                  "label-position": "left",
                  model: _vm.rechargeForm,
                  "status-icon": "",
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("data.payment_type") + ":",
                      prop: "top_up_type",
                      rules: [
                        {
                          required: true,
                          message: "Payment Type cannot be empty",
                          trigger: ["blur", "change"],
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.rechargeForm.top_up_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.rechargeForm, "top_up_type", $$v)
                          },
                          expression: "rechargeForm.top_up_type",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 4 } }, [
                          _vm._v(_vm._s(_vm.$t("data.thai_qr_payment"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("data.payment_account") + ":" } },
                  [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rechargeInfo.issuing_bank_account_num || ""
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("components.amount") + ":" } },
                  [
                    _c("div", [
                      _vm._v(
                        " " + _vm._s(_vm.rechargeInfo.amount || "") + " THB "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("el-divider", { staticClass: "divider" }),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "align-items": "center",
            },
          },
          [
            _c("span", { staticClass: "scan_qr_code_text" }, [
              _vm._v(_vm._s(_vm.$t("data.scan_qr_code"))),
            ]),
            _c("span", { staticClass: "scan_qr_code_tip_text" }, [
              _vm._v(_vm._s(_vm.$t("tips.scan_qr_code_tip"))),
            ]),
            _c("span", { staticClass: "scan_qr_code_tip_text" }, [
              _vm._v(_vm._s(_vm.$t("tips.qr_code_expires_in")) + ": "),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#1D3A71",
                    "font-weight": "600",
                    "font-size": "16px",
                    "margin-left": "4px",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.countdown))]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                class: ["qr-code-container", { expired: _vm.isInvalid }],
              },
              [
                _c("div", { ref: "qrCodeUrl" }),
                _c("div", { staticClass: "qr-code-overlay" }, [
                  _c("div", { staticClass: "qr-code-text" }, [
                    _c("img", {
                      staticStyle: { width: "48px", height: "48px" },
                      attrs: {
                        src: require("@/assets/thai_qr_img/expired.png"),
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("tips.qr_code_expires")) + " "),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  padding: "12px",
                  background: "#1D3A7105",
                  border: "1px solid #D3D7DF",
                  "border-radius": "12px",
                  "margin-top": "12px",
                },
              },
              _vm._l(_vm.srcList, function (channel, index) {
                return _c("el-image", {
                  key: index,
                  staticStyle: {
                    width: "46px",
                    height: "46px",
                    "margin-right": "12px",
                  },
                  attrs: {
                    src: require("@/assets/thai_qr_img/" + channel + ".png"),
                  },
                })
              }),
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-top": "12px" },
                attrs: { disabled: !_vm.isInvalid, type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.goToOpenApiBluepayThaiDynamicQr()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("data.refresh")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }